module.exports = __webpack_public_path__ + "img/1528446432.538c1dbb.jpg";